<template>
  <div v-if="hasVariables" class="flex flex-col gap-4">
    <Field v-for="schemaEntry in normalizedVariablesSchema" :key="schemaEntry.key">
      <FieldLabel :for="`task-template-variable-${schemaEntry.key}`">
        {{ schemaEntry.label }}
      </FieldLabel>

      <Textarea
        v-if="schemaEntry.type === 'textarea'"
        :id="`task-template-variable-${schemaEntry.key}`"
        :model-value="resolveFieldValue(schemaEntry.key)"
        :disabled="disabled"
        rows="3"
        @update:model-value="updateFieldValue(schemaEntry.key, $event)"
      />
      <Input
        v-else
        :id="`task-template-variable-${schemaEntry.key}`"
        :model-value="resolveFieldValue(schemaEntry.key)"
        :disabled="disabled"
        @update:model-value="updateFieldValue(schemaEntry.key, $event)"
      />

      <FieldDescription>
        <span class="font-medium">Token:</span> [[{{ schemaEntry.key }}]]
        <span class="ml-2">{{ schemaEntry.required ? 'Required' : 'Optional' }}</span>
        <span v-if="schemaEntry.sourcesLabel" class="ml-2">Used in: {{ schemaEntry.sourcesLabel }}</span>
      </FieldDescription>

      <FieldError v-if="resolveFieldError(schemaEntry.key)">
        {{ resolveFieldError(schemaEntry.key) }}
      </FieldError>
    </Field>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Input } from '../../../../../../../resources/js/components/ui/input/index.js'
import { Textarea } from '../../../../../../../resources/js/components/ui/textarea/index.js'
import {
  Field,
  FieldDescription,
  FieldError,
  FieldLabel,
} from '../../../../../../../resources/js/components/ui/field/index.js'
import {
  formatTaskTemplateVariableSources,
  resolveTaskTemplateVariableError,
} from '../../utils/taskTemplateVariables.js'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  variablesSchema: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Object,
    default: () => ({}),
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const normalizedVariablesSchema = computed(() => {
  return (Array.isArray(props.variablesSchema) ? props.variablesSchema : [])
    .filter((schemaEntry) => typeof schemaEntry?.key === 'string' && schemaEntry.key.trim() !== '')
    .map((schemaEntry) => ({
      ...schemaEntry,
      label: typeof schemaEntry.label === 'string' && schemaEntry.label.trim() !== ''
        ? schemaEntry.label
        : schemaEntry.key,
      type: typeof schemaEntry.type === 'string' && schemaEntry.type.trim() !== ''
        ? schemaEntry.type
        : 'text',
      required: schemaEntry.required === true,
      sourcesLabel: formatTaskTemplateVariableSources(schemaEntry.sources),
    }))
})

const hasVariables = computed(() => normalizedVariablesSchema.value.length > 0)

const resolveFieldValue = (key) => {
  const value = props.modelValue?.[key]

  return typeof value === 'string' ? value : ''
}

const updateFieldValue = (key, value) => {
  emit('update:modelValue', {
    ...props.modelValue,
    [key]: value,
  })
}

const resolveFieldError = (key) => {
  return resolveTaskTemplateVariableError(props.errors, key)
}
</script>
